module.exports = __webpack_public_path__ + "media/images/pic/anime/cake-57fe1665bc33c2fb5fd3a0779af3045e.svg";